export function saveToken(token: string, refresh: string) {
  localStorage.setItem('token', token);
  localStorage.setItem('refresh_token', refresh);
}
